export default __webpack_public_path__ + "static/media/PinClipart1.53153c42.png";